import { Component, Input, OnInit } from '@angular/core'

import {
  EQUITY_INDEX,
  FIXED_INCOME_INDEX,
} from '../../../constants/constant.content'
import { ETF_DISCLOSURE } from '../../../constants/constant.urls'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import * as configURL from '../../../server/configServer.json'
import { EnvironmentService } from '../../services/environment/environment.service'
import { Fd3ContentService } from '../../services/fd3-content/fd3-content.service'
import { ObservableService } from '../../services/observable-service/observable.service'
import { AssetClassModel } from '../../shared/asset-class-model'
import { FilterModel } from '../../shared/filter-model'

@Component({
  selector: 'fd3-page-footnote',
  templateUrl: './page-footnote.component.html',
  styleUrls: ['./page-footnote.component.scss'],
})
export class PageFootnoteComponent implements OnInit {
  @Input()
  footNoteCaas: any
  footNoteCaasContent: any
  performanceTable = false
  literatureTable = false
  cashEquivalent = false
  index = false
  marketPriceDisclosure: any
  noFilterSelectedForAsset = false

  constructor(
    private readonly observableService: ObservableService,
    private readonly filterModel: FilterModel,
    private readonly fd3ContentService: Fd3ContentService,
    private readonly environmentService: EnvironmentService,
  ) {}

  ngOnInit(): void {
    this.observableService.viewTypeValue.subscribe((value) => {
      this.performanceTable = false
      this.literatureTable = false
      this.showFootNoteComponent(value)
    })
    this.filterModel.telecastFilterBy.subscribe((value: AssetClassModel) => {
      this.cashEquivalent = value.filterByLevel1.cashEquivalent.value
      this.index = this.showIndex(value)
      this.isNoFilterSelectedForAsset(value)
    })

    if (this.footNoteCaas) {
      this.footNoteCaasContent = this.footNoteCaas
      this.footNoteCaasContent.performance.html = this.sanitize(
        this.footNoteCaasContent.performance.html,
      )
      this.footNoteCaasContent.performancePrice.html = this.sanitize(
        this.footNoteCaasContent.performancePrice.html,
      )
      this.footNoteCaasContent.collectiveTrust.html = this.sanitize(
        this.footNoteCaasContent.collectiveTrust.html,
      )
      this.footNoteCaasContent.moneyMarket.html = this.sanitize(
        this.footNoteCaasContent.moneyMarket.html,
      )
      this.footNoteCaasContent.perfPriceLit.html = this.sanitize(
        this.footNoteCaasContent.perfPriceLit.html,
      )
    }
    this.getEtfDisclosures()
  }

  isNoFilterSelectedForAsset(value: AssetClassModel) {
    this.noFilterSelectedForAsset =
      !value.isFilterByLevel1Clicked ||
      this.isStrategySelected(value) ||
      this.isSubAssetSelected(value)
  }

  isSubAssetSelected(value: AssetClassModel) {
    return (
      this.checkConditions(value.filterByLevel1.equity.level2) ||
      this.checkConditions(value.filterByLevel1.fixedIncome.level2) ||
      this.checkConditions(value.filterByLevel1.multiAsset.level2) ||
      this.checkConditions(value.filterByLevel1.cashEquivalent.level2)
    )
  }

  checkConditions(value: any[]) {
    let result = false
    for (const subAsset of value) {
      if (subAsset.value) {
        result = true
      }
    }
    return result
  }

  isStrategySelected(value: AssetClassModel) {
    let result = false
    if (
      value.filterByLevel1.dividend.value ||
      value.filterByLevel1.esg.value ||
      value.filterByLevel1.factorDriven.value ||
      value.filterByLevel1.sectorSpecialties.value
    ) {
      result = true
    }
    return result
  }

  showIndex(value: AssetClassModel) {
    let result = true
    if (value.filterByLevel1.equity.value) {
      result = this.checkIndexConditions(
        value.filterByLevel1.equity.level2,
        EQUITY_INDEX,
      )
    } else if (value.filterByLevel1.fixedIncome.value) {
      result = this.checkIndexConditions(
        value.filterByLevel1.fixedIncome.level2,
        FIXED_INCOME_INDEX,
      )
    }
    return result
  }

  // eslint-disable-next-line complexity
  checkIndexConditions(value: any, rule: any) {
    let isNonIndexSubAssetSelected = false
    let isIndexSubAssetSelected = false
    for (const subAsset of value) {
      if (subAsset.rule !== rule && subAsset.value) {
        isNonIndexSubAssetSelected = true
      }
      if (subAsset.rule === rule && subAsset.value) {
        isIndexSubAssetSelected = true
      }
    }
    return isNonIndexSubAssetSelected || !isIndexSubAssetSelected
  }

  sanitize(data: any) {
    return data
      .replaceAll('&lt;', '<')
      .replaceAll('&gt;', '>')
      .replaceAll('&quot;', '"')
      .replaceAll('&nbsp;', '')
  }

  showFootNoteComponent(value: string) {
    switch (value) {
      case 'monthEndReturnNAV': {
        this.performanceTable = true
        break
      }
      case 'monthEndReturnsMarketETF': {
        this.performanceTable = true
        break
      }
      case 'literature': {
        this.literatureTable = true
        break
      }
    }
  }

  getEtfDiscUrl(): any {
    if (this.environmentService && this.environmentService.envType) {
      return `${
        configURL[this.environmentService.envType].AEM_URL
      }${ETF_DISCLOSURE}`
    }
    return null
  }

  getEtfDisclosures() {
    if (this.getEtfDiscUrl()) {
      this.fd3ContentService
        .getEtfDisclosureContent(this.getEtfDiscUrl())
        .subscribe({
          next: (response: any) => {
            this.setMarketPriceDisclaimer(response)
          },
          error: (error: any) => {
            console.error(error)
          },
        })
    }
  }

  // eslint-disable-next-line complexity
  public setMarketPriceDisclaimer(response: any) {
    if (
      response &&
      response.Data &&
      response.Data.note_etf_market_price_returns &&
      response.Data.note_etf_market_price_returns.content &&
      response.Data.note_etf_market_price_returns.content.NoteContent
    ) {
      this.marketPriceDisclosure =
        response.Data.note_etf_market_price_returns.content.NoteContent
    }
  }
}
